import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { Spin, Row, Col, Select } from 'antd';
import { isEmpty, isUndefined } from 'lodash';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';

import {
    loadWaitingForApprovalActivities,
} from '../actions';
import * as constants from '../constants';

import uistate from '../../uistate';
import common from '../../../common';
import core from '../../core';
import globalappstate from '../../globalappstate';
import currentuser from '../../currentuser';

const { loadUserCounters } = currentuser.actions;
const { AgGridWithState } = core;

const dateFormatter = (params) => {
    if (params.value) {
        return dayjs(params.value).format('DD-MM-YYYY');
    } else {
        return '';
    }
}

class WaitingForApprovalActivitiesGrid extends Component {

    UNSAFE_componentWillMount() {
        this.props.loadWaitingForApprovalActivities();
        this.props.loadUserCounters();
    }
    onDoubleClick = (dataitem, idx) => {
        this.props.history.push(`/app/processingactivities/${dataitem.idProcessingActivity}`, { from: window.location.pathname });
    }

    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'WaitingForApprovalActivitiesGrid', key);
    }

    getGridCols = () => {
        let cols = [
            { key: "statusText", headerName: this.label("Status"), field: "statusText", sortable: true, filter: false, enableRowGroup: true, suppressHeaderMenuButton: true, width: 120, minWidth: 120, maxWidth: 120 },
            { key: "number", width: 110, minWidth: 110, maxWidth: 110, headerName: this.label("Number"), field: "number", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },
            { key: "name", headerName: this.label("Name"), field: "name", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },
            { key: "responsiblePersonDep", headerName: this.label("ResponsiblePersonDep"), field: "responsiblePersonDep", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },
            { key: "company", width: 70, headerName: this.label("Company"), field: "company", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true },
            { key: "reviewDate", width: 110, minWidth: 110, maxWidth: 110, headerName: this.label("ReviewDate"), field: "reviewDate", sortable: true, filter: true, enableRowGroup: false, suppressHeaderMenuButton: true, filter: "agTextColumnFilter", valueFormatter: dateFormatter },
            { key: "businessProcess", headerName: this.label("BusinessProcess"), field: "businessProcess", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },
        ]

        return cols;
    }


    refreshClicked = () => {
        this.props.loadWaitingForApprovalActivities();
        this.props.loadUserCounters();
    }

    render() {
        const loading = this.props.loadingActivities;
        const menuHeight = 45
        const gridHeight = this.props.contentHeight - menuHeight - (this.props.topOffset || 0);
        const columnDefinitions = this.getGridCols();

        return (
            <div className='approvalactivities'>
                <Row className='main-toolbar' style={{ height: menuHeight }} justify="space-around" align='middle' gutter={8}>
                    <Col span={24} >
                        <span className='module-title'>{this.label("WaitingForApprovalActivities")}</span>
                    </Col>
                </Row>
                {loading ? (
                    <div className="loader-content" >
                        <Spin size="large" />
                        <p>{this.label("Loading")}</p>
                    </div>
                ) : (
                    <>
                        <AgGridWithState height={gridHeight} ShowGroupPanel={false} DefaultExpanded={true}
                            lang={this.props.curLanguage}
                            onItemDoubleClicked={this.onDoubleClick}
                            columnDefinitions={columnDefinitions}
                            data={this.props.waitingactivities}
                            onRefresh={this.refreshClicked}
                            labels={this.props.labels}
                        >
                        </AgGridWithState>
                    </>
                )}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        loadingActivities: state[constants.NAME].loadingActivities,
        waitingactivities: state[constants.NAME].waitingactivities,
        contentHeight: state[uistate.constants.NAME].contentheight,
        labels: uistate.selectors.uiLabels(state),
        curLanguage: uistate.selectors.curLanguage(state),
        currentuser: state[currentuser.constants.NAME],
        picklists: globalappstate.selectors.allPicklists(state),
    };
}

export default connect(mapStateToProps,
    {
        loadWaitingForApprovalActivities,
        loadUserCounters,
    })(WaitingForApprovalActivitiesGrid);  